export default "__VITE_ASSET__Cj5EIE4h__"